import { DOMAIN, S3_SEMNEXUS } from "../constants";
import { IMarketingProject } from "../interfaces/marketing-project.interface";

export const MKT_PROJECTS: IMarketingProject[] = [
    {
        name: 'ualett',
        logo: `${DOMAIN}wp-content/uploads/2025/08/icon-1.png`,
        description: 'Ualett is a U.S.-based financial platform serving over 160,000 gig workers, independent contractors, and small business owners. Through its mobile app, Ualett offers fast, no-credit-check cash advances with a flat fee and flexible repayment terms.',
        redirectUrl: 'ualett',
        images: [
            `${DOMAIN}wp-content/uploads/2025/08/ACCOUNT-SETUP.png`,
            `${DOMAIN}wp-content/uploads/2025/08/BENEFITS.png`,
            `${DOMAIN}wp-content/uploads/2025/08/CASH-OTW.png`,
            `${DOMAIN}wp-content/uploads/2025/08/DETAILS.png`,
            `${DOMAIN}wp-content/uploads/2025/08/HOME-1.png`,
            `${DOMAIN}wp-content/uploads/2025/08/LOGIN.png`
        ],
        background: `${DOMAIN}wp-content/uploads/2025/08/bg-1.png`,
        downloadLinks: {
            google: 'https://play.google.com/store/apps/details?id=com.ualett&pcampaignid=web_share',
            apple: 'https://apps.apple.com/us/app/ualett/id1438430972'
        },
        strategy: 'We conducted in-depth market research to define the ideal user persona: a gig worker needing fast, flexible, and transparent cash solutions.',
        optimization: 'Optimized campaign structure, tracking, and audience targeting',
        creative: 'Created and launched targeted ads across Google, Meta, and Apple Search.',
        dynamicContent: [
            {
                type: 'text',
                title: 'Overview',
                content: `Ualett is a U.S.-based financial platform serving over 160,000 gig workers, independent contractors, and small business owners. Through its mobile app, Ualett offers fast, no-credit-check cash advances with a flat fee and flexible repayment terms.`
            },
            {
                type: 'titleBullets',
                title: 'Problem / Challenge',
                nestedBullets: [
                    {
                        subtitle: 'Ualett faced strong competition from fintech apps with:',
                        bullets: [
                            'Hidden fees, limited transparency',
                            'Poor user support',
                            'Inaccessible terms for gig workers'
                        ]
                    },
                    {
                        subtitle: 'To scale effectively, they needed a clear acquisition strategy, stronger messaging, and a reliable lead generation engine.',
                        bullets: []
                    },
                ]
            },
            {
                type: 'bullets',
                title: 'Objectives',
                content: `Increase qualified leads and app downloads,
                Improve brand trust and clarity of messaging,
                Optimize acquisition spend across major ad platforms`
            },
            {
                type: 'titleBullets',
                title: 'Strategy / Approach',
                nestedBullets: [
                    {
                        subtitle: 'We conducted in-depth market research to define the ideal user persona: a gig worker needing fast, flexible, and transparent cash solutions. Based on this, we:',
                        bullets: [
                            'Created and launched targeted ads across Google, Meta, and Apple Search',
                            'Developed ad messaging centered on speed, ease, and no credit checks',
                            'Optimized campaign structure, tracking, and audience targeting'
                        ]
                    }
                ]
            },
            {
                type: 'bullets',
                title: 'Execution',
                content: `Set up conversion tracking and performance analytics across platforms,
                Ran geo-targeted campaigns in high-density gig worker markets,
                A/B tested ad variations for copy and CTA effectiveness,
                Tracked User Experience Using Adjust and gave recommendations to correct any drop offs`
            },
            {
                type: 'titleBullets',
                title: 'Results',
                nestedBullets: [
                    {
                        subtitle: 'Cumulative to date:',
                        bullets: [
                            '544,634 total app installs',
                            '$1,021,570.84 in managed advertising spend',
                            '$1.88 blended cost per install'
                        ]
                    },
                    {
                        subtitle: 'Ongoing monthly performance:',
                        bullets: [
                            'Over $50,000/month in advertising spend managed',
                            'More than 20,000 app downloads every month',
                            '📈 App downloads increased by 40%, month over month',
                            '📈 Leads increased by 30%, month over month'
                        ]
                    }
                ]
            },
            {
                type: 'titleBullets',
                title: 'Key Learnings / Insights',
                nestedBullets: [
                    {
                        subtitle: '',
                        bullets: [
                            'Simplicity, trust, and speed are top priorities for gig workers',
                            'Search-based intent (Google & Apple) drove the highest ROI',
                            'Personalized, regional targeting improved quality and reduced CAC'
                        ]
                    }
                ]
            },
        ]
    },
    {
        name: 'resonante',
        logo: `${DOMAIN}wp-content/uploads/2025/08/icon.png`,
        description: `Resonante is a mental health app that provides a safe, anonymous space for meaningful conversations, ensuring you never feel alone in life's challenges.`,
        redirectUrl: 'resonante',
        images: [
            `${DOMAIN}wp-content/uploads/2025/08/CHAT-2.png`,
            `${DOMAIN}wp-content/uploads/2025/08/CHAT.png`,
            `${DOMAIN}wp-content/uploads/2025/08/HOME.png`,
            `${DOMAIN}wp-content/uploads/2025/08/INTERESTS.png`,
            `${DOMAIN}wp-content/uploads/2025/08/PROFILE.png`
        ],
        background: `${DOMAIN}wp-content/uploads/2025/08/bg.png`,
        downloadLinks: {
            google: 'https://play.google.com/store/apps/details?id=com.resonante.www&pcampaignid=web_share',
            apple: 'https://apps.apple.com/us/app/resonante/id6740175358'
        },
        strategy: 'Identified key drop-off points through funnel analytics',
        optimization: 'Built detailed in-app funnels to understand user behavior across onboarding, engagement, and monetization stages.',
        creative: 'Ran paid acquisition campaigns on Google Ads and Facebook',
        dynamicContent: [
            {
                type: 'text',
                title: 'Overview',
                content: `Support Resonante’s growth as a safe, anonymous space for emotional connection and support by running paid acquisition campaigns, analyzing user experience through in-app funnels, and improving subscription conversion through UX and pricing recommendations`
            },
            {
                type: 'text',
                title: 'Target Persona',
                content: `Following in-depth market research, we identified emotionally overwhelmed Gen Z and millennials who value anonymity, quick access, and peer connection. All campaign strategy and product analysis was aligned with this segment`
            },
            {
                type: 'titleBullets',
                title: 'What We Did',
                nestedBullets: [
                    {
                        subtitle: 'Ran paid acquisition campaigns on Google Ads and Facebook',
                        bullets: [
                            'Google Ads: 3,232 downloads at a cost per install  of $0.78',
                            'Facebook Ads: 2,108 installs at a CPI of $3.52'
                        ]
                    },
                    {
                        subtitle: '',
                        bullets: [
                            'Built detailed in-app funnels to understand user behavior across onboarding, engagement, and monetization stages'
                        ]
                    },
                    {
                        subtitle: '',
                        bullets: [
                            'Identified key drop-off points through funnel analytics'
                        ]
                    },
                    {
                        subtitle: 'Delivered actionable UX/CRO recommendations, including:',
                        bullets: [
                            'Clearer CTAs and more intuitive onboarding steps',
                            'Suggested search functionality in dropdowns',
                            'In-app event tagging for deeper analytics'
                        ]
                    },
                    {
                        subtitle: '',
                        bullets: [
                            'Proposed a price increase from $3.99 to $5.99–6.49/month to better reflect the app’s premium positioning, supported by competitor benchmarking'
                        ]
                    }
                ]
            },
            {
                type: 'bullets',
                title: 'Key Results',
                content: `Scaled acquisition efficiently through paid ads, maintaining a low blended CPI across channels,
                Identified and addressed high-friction areas in the onboarding and subscription process,
                Provided a phased roadmap for event tracking and CRO improvements,
                Delivered strategic insights to boost monetization and App Store positioning`
            }
        ]
    },
    {
        name: 'kicksnap',
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon.png`,
        description: 'KickSnap is a sneaker shopping app that lets users discover and buy sneakers using image recognition, text search, and a centralized marketplace.',
        redirectUrl: 'kicksnap',
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/KICK-RACK.png`,
            `${DOMAIN}wp-content/uploads/2025/04/IMG_0243.png`,
            `${DOMAIN}wp-content/uploads/2025/04/IMG_0242.png`,
            `${DOMAIN}wp-content/uploads/2025/04/IMG_0237.png`,
            `${DOMAIN}wp-content/uploads/2025/04/CAMERA.png`
        ],
        background: `${DOMAIN}wp-content/uploads/2025/04/bg_2.png`,
        downloadLinks: {
            google: 'https://play.google.com/store/apps/details?id=com.kicksnap&pcampaignid=web_share',
            apple: 'https://apps.apple.com/us/app/kicksnap/id6450046203'
        },
        strategy: 'Tested different ad creatives and adjusted targeting based on results. Increased ad spend on high-performing campaigns.',
        optimization: 'Researched high-traffic keywords and optimized app store listings. Updated app titles, descriptions, and visuals to boost search rankings.',
        creative: 'Focused on high-intent keywords like “buy sneakers” and “sneaker search.” Monitored keyword trends and updated ad copy to stay relevant. Used value-based bidding to drive quality installs.',
        dynamicContent: [
            {
                type: 'text',
                title: 'Overview',
                content: `KickSnap is a sneaker shopping app that lets users discover and buy sneakers using image recognition, text search, and a centralized marketplace. SEMNexus was tasked with driving app downloads and user engagement through a strategic combination of Google Ads and App Store Optimization . The goal was to increase user acquisition while maintaining a low cost per conversion through precise keyword targeting and continuous campaign optimization`
            },

            {
                type: 'bullets',
                title: 'Objectives',
                content: `Drive app downloads on iOS and Android,
                          Optimize keyword targeting to improve visibility and conversion rates,
                          Reduce cost per conversion while increasing user engagement`
            },
            {
                type: 'titleBullets',
                title: 'Strategy',
                nestedBullets: [
                    {
                        subtitle: 'Google Ads – Keyword Targeting & Trend Monitoring',
                        bullets: [
                            'Focused on high-intent keywords like “buy sneakers” and “sneaker search.”',
                            'Monitored keyword trends and updated ad copy to stay relevant',
                            'Used value-based bidding to drive quality installs'
                        ]
                    },
                    {
                        subtitle: 'App Store Optimization (ASO)',
                        bullets: [
                            'Researched high-traffic keywords and optimized app store listings',
                            'Updated app titles, descriptions, and visuals to boost search rankings'
                        ]
                    },
                    {
                        subtitle: 'A/B Testing & Performance Monitoring',
                        bullets: [
                            'Tested different ad creatives and adjusted targeting based on results',
                            'Increased ad spend on high-performing campaigns'
                        ]
                    }
                ]
            },
            {
                type: 'conclusion',
                title: 'Conclusion',
                content: `We were able to deliver outstanding results through strategic keyword targeting and real-time campaign adjustments. The Android campaign achieved an exceptionally low cost per conversion demonstrating the effectiveness of the targeting and creative strategy. The iOS campaign showed strong engagement with room for further optimization. This case study highlights SEMNexus’s ability to drive growth and maximize ROAS through expert Google Ads and ASO strategies`
            }
        ]
    },
    {
        name: 'hatched',
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-1.png`,
        description: 'Hatched is a dating app focused on fostering meaningful connections beyond surface-level attraction.',
        redirectUrl: 'hatched',
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/QUESTIONS.png`,
            `${DOMAIN}wp-content/uploads/2025/04/HOME.png`,
            `${DOMAIN}wp-content/uploads/2025/04/CHAT.png`,
            `${DOMAIN}wp-content/uploads/2025/04/CARTON.png`
        ],
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-2.png`,
        downloadLinks: {
            google: 'https://play.google.com/store/apps/details?id=com.hatchmatch.hatch&pcampaignid=web_share',
            apple: 'https://apps.apple.com/us/app/hatched-personality-dating/id1577370215'
        },
        strategy: 'Optimize Facebook Ad account to increase iOS downloads. Increase Android downloads through targeted Google Ads campaigns. Lower cost per conversion while driving high-quality user acquisition.',
        optimization: "Refined audience targeting based on user behavior and interests. Created new ad creatives focused on Hatched's unique value proposition.",
        creative: 'Monitored keyword trends and updated ad copy based on search behavior. Used value-based bidding to maximize quality app installs.',
        dynamicContent: [
            {
                type: 'text',
                title: 'Overview',
                content: `Hatched is a dating app focused on fostering meaningful connections beyond surface-level attraction. Unlike traditional dating apps, Hatched uses an innovative matchmaking algorithm that connects users based on shared values and personality traits through a game-like experience. SEMNexus was tasked with optimizing Hatched’s Facebook Ad account and driving Android downloads through a strategic Google Ads campaign to increase user acquisition and improve ad performance.`
            },

            {
                type: 'bullets',
                title: 'Objectives',
                content: `Optimize Facebook Ad account to increase iOS downloads,
                          Increase Android downloads through targeted Google Ads campaigns,
                          Lower cost per conversion while driving high-quality user acquisition`
            },
            {
                type: 'titleBullets',
                title: 'Strategy',
                nestedBullets: [
                    {
                        subtitle: 'Facebook Ads Optimization',
                        bullets: [
                            'Refined audience targeting based on user behavior and interests',
                            'Created new ad creatives focused on Hatched’s unique value proposition',
                            'Collaborated with UGC Creators to add to the campaigns',
                            'Launched A/B testing to identify high-performing ad variations'
                        ]
                    },
                    {
                        subtitle: 'Google Ads – Keyword Targeting & Trend Monitoring',
                        bullets: [
                            'Monitored keyword trends and updated ad copy based on search behavior',
                            'Used value-based bidding to maximize quality app installs'
                        ]
                    }
                ]
            },
            {
                type: 'conclusion',
                title: 'Conclusion',
                content: `SEMNexus delivered strong results by optimizing Hatched’s Facebook Ad account and executing a high-performance Google Ads strategy. The refined targeting and creative adjustments improved engagement and lowered acquisition costs on Facebook, while the strategic keyword targeting on Google Ads increased Android downloads at a competitive cost per conversion. `
            }
        ]
    },
    {
        name: 'happy mob',
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-2.png`,
        description: 'Happy Mob is a platform that connects users with minority-owned businesses in their area, serving as a directory to promote and support these businesses.',
        redirectUrl: 'happy-mob',
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/SEARCH.png`,
            `${DOMAIN}wp-content/uploads/2025/04/SAVED-BUSINESSES.png`,
            `${DOMAIN}wp-content/uploads/2025/04/HOME-1.png`,
            `${DOMAIN}wp-content/uploads/2025/04/DETAIL.png`,
            `${DOMAIN}wp-content/uploads/2025/04/CATEGORIES.png`
        ],
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-3.png`,
        strategy: 'Increase app downloads through targeted Google Ads campaigns. Improve app store visibility with optimized imagery and keyword-rich descriptions. Lower cost per conversion while attracting high-quality users.',
        optimization: "Conducted keyword research to identify high-traffic, low-competition terms. Designed new app store visuals to highlight the app's mission and value.",
        creative: 'Adjusted keyword targeting based on search trends and performance data. Used value-based bidding to maximize user acquisition while controlling costs.',
        dynamicContent: [
            {
                type: 'text',
                title: 'Overview',
                content: `Happy Mob is a platform that connects users with minority-owned businesses in their area, serving as a directory to promote and support these businesses. The app monetizes through ads and business promotions within the platform, targeting both minority-owned businesses and consumers interested in supporting them. SEMNexus was tasked with driving user acquisition through Google Ads and optimizing the app’s visibility and conversion rates through strategic App Store Optimization (ASO).`
            },

            {
                type: 'bullets',
                title: 'Objectives',
                content: `Increase app downloads through targeted Google Ads campaigns,
                          Improve app store visibility with optimized imagery and keyword-rich descriptions,
                          Lower cost per conversion while attracting high-quality users`
            },
            {
                type: 'titleBullets',
                title: 'Strategy',
                nestedBullets: [
                    {
                        subtitle: 'Google Ads – Keyword Targeting & Trend Monitoring',
                        bullets: [
                            'Adjusted keyword targeting based on search trends and performance data',
                            'Used value-based bidding to maximize user acquisition while controlling costs'
                        ]
                    },
                    {
                        subtitle: 'App Store Optimization ',
                        bullets: [
                            'Conducted keyword research to identify high-traffic, low-competition terms',
                            'Designed new app store visuals to highlight the app’s mission and value',
                            'Optimized app titles and descriptions with strategic keywords to improve search rankings'
                        ]
                    },
                    {
                        subtitle: 'A/B Testing & Performance Monitoring',
                        bullets: [
                            'Tested multiple ad variations and adjusted based on conversion performance',
                            'Increased ad spend on high-performing campaigns while pausing underperformers',
                            'Monitored app store performance and adjusted listing content to improve conversion rates'
                        ]
                    }
                ]
            },
            {
                type: 'conclusion',
                title: 'Conclusion',
                content: `SEMNexus delivered strong results for Happy Mob through a data-driven Google Ads and ASO strategy. The precise keyword targeting and value-based bidding helped drive high-quality app installs at a competitive cost per conversion. The app store optimization efforts enhanced the app’s visibility and improved conversion rates, reinforcing Happy Mob’s positioning as the go-to platform for supporting minority-owned businesses. `
            }
        ]
    },
    {
        name: 'foojan',
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-3.png`,
        description: 'Foojan is a mental health and self-improvement app that guides users through a transformative journey to reduce stress, manage anxiety, and enhance overall well-being.',
        redirectUrl: 'foojan',
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/RESULTS.png`,
            `${DOMAIN}wp-content/uploads/2025/04/LIFE-AREAS.png`,
            `${DOMAIN}wp-content/uploads/2025/04/HOME-2.png`,
            `${DOMAIN}wp-content/uploads/2025/04/TIMER.png`
        ],
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-4.png`,
        downloadLinks: {
            google: 'https://play.google.com/store/apps/details?id=com.foojan.app&pcampaignid=web_share',
            apple: 'https://apps.apple.com/us/app/foojan-self-improvement-app/id1609189394'
        },
        strategy: 'Increase app downloads through targeted ad campaigns. Identify and fix onboarding issues to improve user retention and engagement. Lower cost per conversion while maximizing high-quality installs.',
        optimization: 'Updated ad copy based on search trends and user behavior. Adjusted bidding strategy to maximize ROAS while maintaining a low cost per install.',
        creative: 'Targeted users interested in mental health, wellness, and self-improvement. Used lookalike audiences and interest-based targeting to improve acquisition quality.',
        dynamicContent: [
            {
                type: 'text',
                title: 'Overview',
                content: `Foojan is a mental health and self-improvement app that guides users through a transformative journey to reduce stress, manage anxiety, and enhance overall well-being. Using a multi-modality approach that integrates cognitive, behavioral, emotional, and body-mind theories, Foojan helps users achieve personal growth and emotional healing.
                SEMNexus was tasked with driving app downloads through Facebook Ads and Google Ads for both Android and iOS. Additionally, SEMNexus conducted a comprehensive user experience (UX) analysis and provided actionable recommendations to improve onboarding and user retention.`
            },

            {
                type: 'bullets',
                title: 'Objectives',
                content: `Increase app downloads on iOS and Android through targeted ad campaigns,
                          Identify and fix onboarding issues to improve user retention and engagement,
                          Lower cost per conversion while maximizing high-quality installs`
            },
            {
                type: 'titleBullets',
                title: 'Strategy',
                nestedBullets: [
                    {
                        subtitle: 'Facebook Ads – Targeted Audience Segmentation',
                        bullets: [
                            'Targeted users interested in mental health, wellness, and self-improvement',
                            'Tested various ad creatives and CTAs to identify high-performing variations',
                            'Used lookalike audiences and interest-based targeting to improve acquisition quality'
                        ]
                    },
                    {
                        subtitle: 'Google Ads – Keyword Targeting & Trend Monitoring',
                        bullets: [
                            'Updated ad copy based on search trends and user behavior',
                            'Adjusted bidding strategy to maximize ROAS while maintaining a low cost per install'
                        ]
                    },
                    {
                        subtitle: 'UX Analysis & Onboarding Fixes',
                        bullets: [
                            'Analyzed user behavior through in-app analytics to identify drop-off points during onboarding',
                            'Recommended simplification of onboarding steps to reduce friction',
                            'Suggested clearer value propositions and improved CTAs to enhance user engagement'
                        ]
                    }
                ]
            },
            {
                type: 'bullets',
                title: 'Results',
                content: `John Design`
            },
            {
                type: 'conclusion',
                title: 'Conclusion',
                content: `SEMNexus successfully increased Foojan’s app downloads and user engagement through a strategic combination of Facebook Ads and Google Ads. By optimizing audience targeting and continuously adjusting ad copy based on performance data, SEMNexus delivered a strong return on ad spend and increased user acquisition.                
                The UX analysis and onboarding improvements directly enhanced user retention, ensuring that new users were more engaged and better supported from the start. This case study highlights  our ability to deliver results through a holistic approach combining paid acquisition and user experience optimization.`
            }
        ]
    },
    {
        name: 'cauldy',
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-4.png`,
        description: 'Cauldy is a Gen Z-designed social media platform focused on meaningful, anonymous interactions.',
        redirectUrl: 'cauldy',
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/IMG_0498.png`,
            `${DOMAIN}wp-content/uploads/2025/04/IMG_0497.png`,
            `${DOMAIN}wp-content/uploads/2025/04/IMG_0496.png`,
            `${DOMAIN}wp-content/uploads/2025/04/IMG_0495.png`
        ],
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-5.png`,
        downloadLinks: {
            google: 'https://play.google.com/store/apps/details?id=com.bleep.btw&pcampaignid=web_share',
            apple: 'https://apps.apple.com/us/app/cauldy/id1668340510'
        },
        strategy: 'Increase app downloads. Improve app store visibility and conversion rates. Develop a high-quality pitch deck to secure investor funding.',
        optimization: 'Optimized app descriptions, visuals, and metadata to improve search ranking and conversion.',
        creative: 'Targeted Gen Z users with tailored ad creatives (video, carousel, and story ads).',
        dynamicContent: [
            {
                type: 'text',
                title: 'Overview',
                content: `Cauldy is a Gen Z-designed social media platform focused on meaningful, anonymous interactions. SEMNexus was tasked with driving app downloads through Google Ads and Facebook Ads, improving visibility through App Store Optimization (ASO), and creating a professional pitch deck for investors`
            },

            {
                type: 'bullets',
                title: 'Objectives',
                content: `Increase app downloads on iOS and Android, 
                Improve app store visibility and conversion rates, 
                Develop a high-quality pitch deck to secure investor funding`
            },

            {
                type: 'list',
                title: 'Strategy',
                content: `Google Ads – Focused on high-intent keywords like "anonymous social media" and used value-based bidding to maximize installs,
                        Facebook Ads – Targeted Gen Z users with tailored ad creatives (video, carousel, and story ads),
                        ASO – Optimized app descriptions, visuals, and metadata to improve search ranking and conversion,
                        UX Audit – Simplified signup process and added an interactive walkthrough to improve onboarding,
                        Pitch Deck – Designed a compelling pitch deck highlighting Cauldy’s growth potential`
            },
            {
                type: 'titleBullets',
                title: 'Results',
                nestedBullets: [
                    {
                        subtitle: 'Google Ads',
                        bullets: [
                            'Downloads: 38,067',
                            'Cost: $2,352',
                            'CPI: $0.06'
                        ]
                    },
                    {
                        subtitle: 'Facebook Ads',
                        bullets: [
                            'Downloads: 2,011',
                            'Cost: $1,809',
                            'CPI: $0.90'
                        ]
                    }
                ]
            },
            {
                type: 'conclusion',
                title: 'Conclusion',
                content: `SEMNexus drove over 40,000 downloads at a highly competitive cost per install through strategic ad targeting and ASO. The onboarding improvements boosted retention, and the pitch deck positioned Cauldy for investor success.`
            }
        ]
    },
    {
        name: "Ramp Assist Boating",
        description: "ZF, a pioneering player in the boating industry, developed a cutting-edge boating app aimed at streamlining the boat retrieval process and enhancing users' boating experiences.",
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-5.png`,
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/image-2-1.png`,
            `${DOMAIN}wp-content/uploads/2025/04/image-5.png`,
            `${DOMAIN}wp-content/uploads/2025/04/image-1-1.png`
        ],
        redirectUrl: "ramp-assist-boating",
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-6.png`,
        downloadLinks: {
            apple: 'https://apps.apple.com/us/app/ramp-assist-smart-boating/id1640103295?',
            google: ''
        },
        strategy: "Highlighted the app's advanced AI technology, emphasizing real-time functionality through relatable scenarios.",
        optimization: "The combined approach of paid digital marketing and organic posting strategies led to increased app downloads and a solid foundation for the app's future growth in the boating industry.",
        creative: "Created visually engaging advertisements that showcased the app's features and benefits in real-life boating scenarios. -Designed clear and concise messaging that resonated with both novice and experienced boaters."
    },
    {
        name: "ultimate playlist",
        description: "The Ultimate Playlist App is a revolutionary internet radio platform that offers users a unique opportunity to win cash rewards simply by listening to music!",
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-6.png`,
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/2-1.png`,
            `${DOMAIN}wp-content/uploads/2025/04/1.png`,
            `${DOMAIN}wp-content/uploads/2025/04/3.png`
        ],
        redirectUrl: "ultimate-playlist",
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-7.png`,
        strategy: 'We emphasized the simple process as well as the exciting opportunities for both daily cash drawings and the jackpot game.',
        optimization: 'To incentivize engagement and participation, we designed in-app prompts and notifications to guide users. We lead them through the process of listening to playlists, rating songs, and adding them to their Apple Music playlists.',
        creative: 'Video tutorials on how to use the app, success stories of previous winners, and explanations of the jackpot game. We shared this content across social media and within the app.'
    },
    {
        name: "Fuel Your Side Hustle",
        description: "Embracing the spirit of innovation, FYSH stands as a dynamic platform committed to supporting the side-hustle economy by providing essential tools and infrastructure for building and growing personal businesses.",
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-7.png`,
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/image3.png`,
            `${DOMAIN}wp-content/uploads/2025/04/image-1-2.png`,
            `${DOMAIN}wp-content/uploads/2025/04/image-6.png`
        ],
        redirectUrl: "fysh",
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-8.png`,
        strategy: "The strategy focused on creating a strong brand presence, engaging the target audience through various channels, and emphasizing the unique benefits of FYSH's app.",
        optimization: 'By skillfully integrating relevant keywords, attractive visuals, and compelling descriptions, we successfully optimized app listings and boosted visibility amongst potential users.',
        creative: ' We crafted informative and engaging content that highlighted the benefits of using FYSH. Its way of simplifying schedules, management, and invoicing were just some of the virtues we spotlighted for side hustlers.'
    },
    {
        name: "winquik",
        description: "WinQuik is the newest live trivia quiz app featuring dynamic personalities from all avenues of entertainment.",
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-8.png`,
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/002.png`,
            `${DOMAIN}wp-content/uploads/2025/04/001.png`,
            `${DOMAIN}wp-content/uploads/2025/04/003.png`
        ],
        redirectUrl: "winquik",
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-9.png`,
        strategy: "Our strategy was to focus on the fun factor of Winquik. Full refresh of Winquik's App Store imagery and description. We used a combination of App Store/Play Store Ads & Social Media to acquire an active user base.",
        optimization: "We first optimized their store listing to incorporate various targeted keywords and provided an update to their app store imagery. This helped provide a solid brand to their store listing.",
        creative: "The focus of our ads was to create fun and energetic videos that focused on Winquik's key features as well as the app's celebrity guests."
    },
    {
        name: "tito",
        description: "Tito shows you what's happening around you in real-time by combining user photos & videos with content curated by local experts. It's Yelp for what's happening right now!",
        logo: `${DOMAIN}wp-content/uploads/2025/04/icon-9.png`,
        images: [
            `${DOMAIN}wp-content/uploads/2025/04/01-1.png`,
            `${DOMAIN}wp-content/uploads/2025/04/02-1.png`,
            `${DOMAIN}wp-content/uploads/2025/04/03-1.png`
        ],
        redirectUrl: "tito",
        background: `${DOMAIN}wp-content/uploads/2025/04/bg-10.png`,
        strategy: "Our strategy was to focus on the app's ability to provide up-to-the-minute information on events and activities happening nearby.",
        optimization: 'We first optimized their store listing to incorporate various targeted keywords and provided an update to their app store imagery. This helped provide a solid brand to their store listing.',
        creative: 'Our focus was to create exciting video ads that visualized just how exciting life in the city can be when you can take full advantage of Tito!'
    },
    {
        name: "Pulse Briefing",
        description: "Support Pulse Briefing’s growth by scaling user acquisition through paid ads, analyzing early-stage user experience, and delivering actionable UX and CRO recommendations to increase activation and long-term retention.",
        logo: `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/icon.jpg`,
        images: [
            `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/LOGIN.png`,
            `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/HOME.png`,
            `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/BOOKMARKED.png`,
            `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/LOCATIONS.png`,
            `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/NEWS.png`,
            `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/SOURCES.png`,
            `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/PREFERENCES.png`,
        ],
        redirectUrl: "pulse-briefing",
        background: `${S3_SEMNEXUS}/projects/marketing/pulse_briefing/banner.jpg`,
        strategy: "Our strategy was to focus on the app's ability to provide up-to-the-minute information on events and activities happening nearby.",
        optimization: 'We first optimized their store listing to incorporate various targeted keywords and provided an update to their app store imagery. This helped provide a solid brand to their store listing.',
        creative: 'Our focus was to create exciting video ads that visualized just how exciting life in the city can be when you can take full advantage of Tito!',
        dynamicContent: [
            {
                type: 'text',
                title: 'Objective',
                content: `Support Pulse Briefing’s growth by scaling user acquisition through paid ads, analyzing early-stage user experience, and delivering actionable UX and CRO recommendations to increase activation and long-term retention.`
            },

            {
                type: 'text',
                title: 'Target Persona',
                content: `Based on market research, we targeted time-constrained professionals and Gen Z users looking for personalized, clutter-free news updates in under two minutes per day.`
            },
            {
                type: 'titleBullets',
                title: 'What We Did',
                nestedBullets: [
                    {
                        subtitle: 'User Acquisition:',
                        bullets: [
                            ' Launched Facebook and Google Ads campaigns, generating 18,000 installs at a blended CPI under $0.50',
                        ]
                    },
                    {
                        subtitle: 'UX Analysis:',
                        bullets: [
                            `Built in-app funnels to track onboarding, engagement, and drop-off points`
                        ]
                    },
                    {
                        subtitle: 'CRO Recommendations:',
                        bullets: [
                            'Delivered UX and copy improvements to reduce friction, boost activation, and guide users through the core features'
                        ]
                    },
                    {
                        subtitle: 'Event Tracking:',
                        bullets: [
                            'Structured all key in-app events for clear behavioral tracking across the customer journey'
                        ]
                    }
                ]
            },
            {
                type: 'bullets',
                title: 'Key Insights and Outcomes',
                content: `Identified onboarding and sign-in steps with drop-offs exceeding 50%,
                Rewrote core onboarding copy to emphasize user benefits and drive completion,
                Proposed visual hierarchy improvements to increase CTA clarity and reduce hesitation,
                Recommended phased feature unlocking to support retention and app stickiness`
            },
        ]
    },
    {
        name: "TackOn",
        description: "Help TackOn grow its two-sided marketplace by driving app installs from both contractors and clients, and improving conversion through UX analysis and CRO recommendations.",
        logo: `${S3_SEMNEXUS}/projects/marketing/tackon/icon (2).jpg`,
        images: [
            `${S3_SEMNEXUS}/projects/marketing/tackon/LOGIN.png`,
            `${S3_SEMNEXUS}/projects/marketing/tackon/HOME.png`,
            `${S3_SEMNEXUS}/projects/marketing/tackon/DESCRIPTION.png`,
            `${S3_SEMNEXUS}/projects/marketing/tackon/CALENDAR.png`,
            `${S3_SEMNEXUS}/projects/marketing/tackon/JOB ACCEPT.png`,
            `${S3_SEMNEXUS}/projects/marketing/tackon/JOB TYPE.png`,
            `${S3_SEMNEXUS}/projects/marketing/tackon/REVIEW.png`,
        ],
        redirectUrl: "tackOn",
        background: `${S3_SEMNEXUS}/projects/marketing/tackon/banner.jpg`,
        strategy: "Our strategy was to focus on the app's ability to provide up-to-the-minute information on events and activities happening nearby.",
        optimization: 'We first optimized their store listing to incorporate various targeted keywords and provided an update to their app store imagery. This helped provide a solid brand to their store listing.',
        creative: 'Our focus was to create exciting video ads that visualized just how exciting life in the city can be when you can take full advantage of Tito!',
        dynamicContent: [
            {
                type: 'text',
                title: 'Objective',
                content: `Help TackOn grow its two-sided marketplace by driving app installs from both contractors and clients, and improving conversion through UX analysis and CRO recommendations.`
            },
            {
                type: 'titleBullets',
                title: 'Target Persona',
                nestedBullets: [
                    {
                        subtitle: 'We focused on two main personas:',
                        bullets: [
                            'Contractors looking for fast, local job opportunities',
                            'Clients needing vetted service providers with minimal effort',
                        ]
                    }
                ]
            },
            {
                type: 'titleBullets',
                title: 'What We Did',
                nestedBullets: [
                    {
                        subtitle: 'User Acquisition:',
                        bullets: [
                            '1,000 installs via Facebook',
                            '1,200 installs via Google Ads',
                            'With a blended CPI well within performance benchmarks'
                        ]
                    },
                    {
                        subtitle: 'UX and Funnel Audit',
                        bullets: [
                            `Conducted a full UX walkthrough and funnel review, focusing on onboarding, job posting, and profile completion flows.`
                        ]
                    },
                    {
                        subtitle: 'CRO Recommendations:',
                        bullets: [
                            'Clearer CTA hierarchy to guide job posting',
                            'Social login implementation (Google, Apple) to reduce signup friction',
                            'Progress bars, smart defaults, and guided tooltips to improve task completion',
                            'Microcopy and trust indicators to reassure and onboard users more effectively'
                        ]
                    }
                ]
            },
            {
                type: 'bullets',
                title: 'Key Insights and Outcomes',
                content: `Major drop-offs were identified in the welcome, login, and job posting flows, primarily due to unclear paths and friction-heavy screens,
                Suggested structural changes to simplify user decision-making post-login and reduce overwhelm,
                Highlighted missing event tracking that limited behavioral insight — emphasized the need for full event implementation to support ongoing optimization,
                Provided a clear roadmap for improving user engagement and activation across both user types`
            },
        ]
    },
    {
        name: "MeetAmore",
        description: "Support the launch of MeetAmore’s MVP, a self-discovery–driven dating app, by driving high-volume installs at low cost. The goal was to gather enough user data to inform UX improvements and define features for the next version of the app.",
        logo: `${S3_SEMNEXUS}/projects/marketing/meetamore/icon.jpg`,
        images: [
            `${S3_SEMNEXUS}/projects/marketing/meetamore/CHOOSE GUIDE.png`,
            `${S3_SEMNEXUS}/projects/marketing/meetamore/GUIDE.png`,
            `${S3_SEMNEXUS}/projects/marketing/meetamore/HOME.png`,
            `${S3_SEMNEXUS}/projects/marketing/tackon/CALENDAR.png`,
            `${S3_SEMNEXUS}/projects/marketing/meetamore/MY PROFILE.png`,
        ],
        redirectUrl: "meet-amore",
        background: `${S3_SEMNEXUS}/projects/marketing/meetamore/banner.jpg`,
        strategy: "Our strategy was to focus on the app's ability to provide up-to-the-minute information on events and activities happening nearby.",
        optimization: 'We first optimized their store listing to incorporate various targeted keywords and provided an update to their app store imagery. This helped provide a solid brand to their store listing.',
        creative: 'Our focus was to create exciting video ads that visualized just how exciting life in the city can be when you can take full advantage of Tito!',
        dynamicContent: [
            {
                type: 'text',
                title: 'Objective',
                content: `Support the launch of MeetAmore’s MVP, a self-discovery–driven dating app, by driving high-volume installs at low cost. The goal was to gather enough user data to inform UX improvements and define features for the next version of the app.`
            },
            {
                type: 'text',
                title: 'Target Persona',
                content: 'The app targeted Gen Z and millennial users looking for emotional compatibility, self-reflection, and non-traditional dating paths. Emotional growth and compatibility were positioned as core app values.'
            },
            {
                type: 'titleBullets',
                title: 'What We Did',
                nestedBullets: [
                    {
                        subtitle: 'User Acquisition',
                        bullets: [
                            '3,100 installs',
                            'At a cost per install (CPI) of $0.17 Campaigns were optimized to bring in a broad early-stage user base for testing behavior and drop-off points.',
                        ]
                    },
                    {
                        subtitle: 'UX and Funnel Audit',
                        bullets: [
                            `Conducted a full audit of the onboarding experience, profile setup, and interaction flows. Reviewed friction points and emotional barriers to engagement.`
                        ]
                    },
                    {
                        subtitle: 'Event Tracking Framework',
                        bullets: [
                            'Onboarding (e.g., first open, sign-in, Google/Apple login, tutorial completion)',
                            'User engagement (e.g., profile actions, feature access, messaging)',
                            'Monetization (e.g., shop views, subscription clicks, gem purchases)'
                        ]
                    },
                    {
                        subtitle: 'Recommendations for Future Versions',
                        bullets: [
                            'Refined onboarding sequence to reduce cognitive load and early drop-offs',
                            'Suggested more intuitive visual hierarchy and progress indicators',
                            'Highlighted behavioral patterns tied to subscription intent and core feature use',
                            'Provided roadmap for future feature prioritization based on tracked usage'
                        ]
                    }
                ]
            },
            {
                type: 'bullets',
                title: 'Key Insights and Outcomes',
                content: `Successfully gathered behavioral data from over 3,000 users during MVP phase,
                Maintained a low CPI of $0.17, maximizing reach and learning per dollar,
                Identified key friction points and engagement triggers to shape next app version,
                Delivered a structured analytics foundation to guide product and design decisions`
            },
        ]
    },
];